import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Flex,
  Input,
  Modal,
  Upload,
  Space,
  Image,
  message,
} from "antd";
import {
  InboxOutlined,
  FileExcelOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import formatImport from "../../../assets/image/formatImport.png";
import API from "../../../services/api-request";

const { Search } = Input;
const { Dragger } = Upload;

function FilterMenu(props) {
  // Filter Menu Variable & Function
  const onSearch = (value) => props.onSearch(value);
  const [showFilter, setShowFilter] = useState(false);
  const [filterMenu] = Form.useForm();
  const onFinishFilter = (values) => {
    console.log("Filter Query:", values);
    filterMenu.resetFields();
  };
  const onFinishFailedFilter = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // Import Variable & Function
  const [showImport, setShowImport] = useState(false);
  const [file, setFile] = useState();
  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const onCancel = () => {
    setShowImport(false);
    setFile();
  };
  const onChange = (info) => {
    const { status } = info.file;

    setFile(info.file.originFileObj);
  };

  const handleImport = () => {
    const formData = new FormData();

    const dataForm = { file: file };

    for (const property in dataForm) {
      formData.append(`${property}`, dataForm[property]);
    }

    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    if (!file) {
      message.info("Can't upload empty file!");
    } else {
      API.Post("user/upload", formData)
        .then(() => {
          message.success("File has been uploaded");
          props.onGetUsers();
          setFile([]);
          setShowImport(false);
        })
        .catch((err) => {
          message.info("Failed upload file");
        });
    }
  };

  return (
    <>
      {/* Menu Bar */}
      <Row
        gutter={[8, 8]}
        justify={"end"}
        align="center"
        style={{ marginBottom: "8px" }}
      >
        <Col>
          <Search
            placeholder="Search..."
            allowClear
            onSearch={onSearch}
            style={{ width: 200 }}
          />
          {/* <Button
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={() => props.exportExcel()}
            ></Button>
            <Button
              type="primary"
              icon={<UploadOutlined />}
              onClick={() => setShowImport(true)}
            /> */}
        </Col>
        <Col>
          <Button type="primary" onClick={() => props.onShowAdd(true)}>
            + Add User
          </Button>
        </Col>
      </Row>

      {/* Modal Import */}
      <Modal
        title="Import User List"
        open={showImport}
        onCancel={onCancel}
        footer={[
          <Button key="back" type="default" onClick={onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleImport}>
            Import
          </Button>,
        ]}
      >
        <Flex vertical gap="middle" justify="center">
          <span>Example Format:</span>
          <Image width={470} src={formatImport} />
          <Dragger
            maxCount={1}
            name="file"
            multiple={false}
            accept=".xlsx, .csv"
            customRequest={dummyRequest}
            onChange={onChange}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">Upload .xlsx or .csv file</p>
          </Dragger>
        </Flex>
      </Modal>
    </>
  );
}

export default FilterMenu;
